// Maps the 15 canonical Pocket theme names (services/ThemeLibraryBuilder.js
// SEED_THEMES on the backend) to a branch/group node in the skill tree
// (see ./data.js). Deliberately coarse: a theme like "Forehand Volley"
// covers a dozen individual leaf ratings (flat/slice/dropshot x
// depth/direction/height/power/touch), so it maps to the group node that
// contains all of them rather than guessing at one specific leaf.
export const THEME_TO_SKILL_NODE = {
  'Forehand Off the Glass': 'tech-def-ofglass-fh',
  'Forehand Volley': 'tech-att-fh-volley',
  'Forehand Drive': 'tech-def-direct-fh',
  'Forehand Slice': 'tech-def-direct-fh-slice',

  'Backhand Vibora': 'tech-att-overhead-vibora',
  'Backhand Slice': 'tech-def-direct-bh-slice',
  'Backhand Volley': 'tech-att-bh-volley',
  'Backhand Drive': 'tech-def-direct-bh',

  'Return of Serve': 'tech-def-return',
  'Flat Serve': 'tech-att-serve',
  'Slice Serve': 'tech-att-serve',

  'Court Positioning': 'tactics',
  'Footwork': 'brawn-footwork',
  'Aggressive Play': 'tech-attack',
  'Defensive Play': 'tech-defense',
};

export function getSkillNodeForTheme(themeName) {
  return THEME_TO_SKILL_NODE[themeName] || null;
}
